import React from 'react';
import { Button, Card, DashChart, DashSlider, Dropdown, Icon, Monitoring, Sensor } from 'components';
import { Div, H2, H3, RowDiv, Section, CenterRowDiv, Text } from 'styles';

function DashboardView({
  filters,
  onChange,
  sampleList,
  sensorList,
  isAll,
  checkedItems,
  singleChange,
  allChange,
  sensorDeleteAll,
  sensorDeleteItem,
}) {
  return (
    <Section>
      <H2 $display="none">Dashboard</H2>
      <H3 $type="b24" $color="assistive">
        전체
      </H3>
      <RowDiv $gap={24} $marginTop={24}>
        <Card icon="Info" title="농장정보" $width={476}>
          <RowDiv $gap={12}>
            <Div $width={320}>
              <Text $type="m14" $color="supportive" $padding="11px 0">
                농장이름
              </Text>
              <Text $type="b24" $height={43} $marginTop={4}>
                청오 엔지니어링
              </Text>
              <Text $type="m14" $color="supportive" $marginTop={16}>
                농장위치
              </Text>
              <Div $minHeight={68} $maxHeight={68} $marginTop={4} $overflowY="auto">
                <Text $type="18">대전광역시 대덕구 대화로 32번길 60-9</Text>
              </Div>
            </Div>
            <CenterRowDiv $justifyContent="center" $width={96} $height={96} $borderRadius={32} $bgColor="#ADE5F9">
              <Icon name="KMA" $pathFill="#00A8F0" $width={36} $height={36} />
            </CenterRowDiv>
          </RowDiv>
        </Card>
        <Card icon="Info" title="식물 공장 모니터링" sub="총 2공장" $width={676} $flex={1}>
          <DashSlider />
        </Card>
      </RowDiv>
      <RowDiv $gap={24} $margin="24px 0">
        <Card
          icon="KMA"
          $pathFill="primary400"
          title="기상 데이터"
          $width={676}
          $flex={1}
          desc={
            <Dropdown
              name="val1"
              value={filters.val1}
              onChange={onChange}
              $maxHeight={140}
              list={[
                { label: '선택', value: '0' },
                { label: '온도', value: '1' },
                { label: '습도', value: '2' },
                { label: '풍향', value: '3' },
                { label: '풍속', value: '4' },
              ]}
            />
          }
        >
          <DashChart list={sampleList} $height={204} />
        </Card>
        <Card icon="Sun" title="외부 조건 모니터링" $width={476}>
          <Monitoring />
        </Card>
      </RowDiv>
      
      {/* <Input error label="Label" subLabel="장비제어조건" placeholder="온도값 입력" unit="℃" />
       */}
    </Section>
  );
}

export default DashboardView;
